import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { APIProvider } from '@vis.gl/react-google-maps'; // ÚJ IMPORT
import Navbar from './components/Navbar';
import PrivacyPolicy from './PrivacyPolicy';
import RegisterForm from './components/RegisterForm';
import AccountDeletionPage from './components/AccountDeletionPage';
import KapcsolatOldal from './components/Contacts';
import CreateCompetitionPage from './components/CreateCompetitionPage';
import EventsListPage from './components/EventsListPage';
import FullViewCompetition from './components/FullViewCompetition';

// --- ÚJ IMPORT ---
import HomePage from './components/HomePage'; 

// --- SZEREPKÖR ALAPÚ OLDALAK IMPORTÁLÁSA ---
import ClubDashboard from './components/clubs/ClubDashboard';
import EditCompetitionPage from './components/clubs/EditCompetitionPage'; 
import CompetitionOffice from './components/clubs/CompetitionOffice';

import CompetitorDashboard from './components/competitors/CompetitorDashboard.js';

// --- ÚJ: Firebase auth és firestore a profil alatti user lekéréshez ---
import { onAuthStateChanged, signOut } from 'firebase/auth'; // FRISSÍTVE: signOut hozzáadva
import { auth, db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';
import { ALLOWED_UIDS } from './constants/Whitelist'; // ÚJ IMPORT

// --- ÚJ: Globális sorompó ellenőrzés ---
function useWhitelistGatekeeper() {
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user && !ALLOWED_UIDS.includes(user.uid)) {
        console.warn("Hozzáférés megtagadva: UID nincs a fehérlistán.");
        await signOut(auth);
      }
    });
    return () => unsubscribe();
  }, []);
}

// --- ÚJ: Biztonságos Wrapper a CompetitorDashboard-hoz, hogy átadja a currentUser-t ---
function CompetitorRouteWrapper() {
  const [currentUser, setCurrentUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user && ALLOWED_UIDS.includes(user.uid)) { // FRISSÍTVE: Csak ha a fehérlistán van
        try {
          const userDoc = await getDoc(doc(db, 'users', user.uid));
          if (userDoc.exists()) {
            const data = userDoc.data();
            setCurrentUser({
              ...user,
              displayName: `${data.lastName || ''} ${data.firstName || ''}`.trim() || user.displayName
            });
          } else {
            setCurrentUser(user);
          }
        } catch (e) {
          setCurrentUser(user);
        }
      } else {
        setCurrentUser(null);
      }
      setLoadingUser(false);
    });
    return () => unsubscribe();
  }, []);

  if (loadingUser) {
    return <div style={{ textAlign: 'center', padding: '50px', fontFamily: 'Arial' }}>Felhasználó ellenőrzése... 🏹</div>;
  }

  if (!currentUser) {
    return <div style={{ textAlign: 'center', padding: '50px', fontFamily: 'Arial' }}>Kérlek jelentkezz be a profil eléréséhez!</div>;
  }

  return <CompetitorDashboard currentUser={currentUser} onLogout={() => auth.signOut()} />;
}


function App() {
  useWhitelistGatekeeper(); // ÚJ: Minden renderelésnél/indulásnál ellenőrzi a jogosultságot

  return (
    <APIProvider apiKey={'AIzaSyCUQ1dNjylL6QZRs6nWbVyfKRSarbEXgKI'} libraries={['places', 'marker']}>
      <Router>
        <Navbar />
        <Routes>
          {/* KEZDŐOLDAL - Most már a HomePage komponenst használja */}
          <Route path="/" element={<HomePage />} />

          {/* ÁLTALÁNOS ÚTVONALAK */}
          <Route path="/adatvedelem" element={<PrivacyPolicy />} />
          <Route path="/regisztracio" element={<RegisterForm />} />
          <Route path="/fioktorles" element={<AccountDeletionPage />} />
          <Route path="/kapcsolat" element={<KapcsolatOldal />} />
          <Route path="/verseny-letrehozas" element={<CreateCompetitionPage />} />
          <Route path="/verseny-szerkesztes/:id" element={<EditCompetitionPage />} />
          <Route path="/versenyiroda/:id" element={<CompetitionOffice />} />
          <Route path="/versenyek" element={<EventsListPage />} />
          <Route path="/verseny/:id" element={<FullViewCompetition />} />

          {/* EGYESÜLETI ÚTVONAL */}
          <Route path="/egyesulet-dashboard" element={<ClubDashboard />} />

          {/* VERSENYZŐI ÚTVONAL - Módosítva a CompetitorRouteWrapper-rel */}
          <Route path="/profil" element={<CompetitorRouteWrapper />} />

          {/* VERSENY NEVEZÉS */}
          <Route
            path="/nevezes/:eventId"
            element={<div>Nevezési oldal (Fejlesztés alatt)</div>}
          />

        </Routes>
      </Router>
    </APIProvider>
  );
}

export default App;

